var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-list-group-item', {
    staticClass: "d-flex align-items-center border-0 position-relative chatroom-list-item",
    attrs: {
      "variant": _vm.variant
    }
  }, [_vm.isPinned ? _c('span', {
    staticClass: "pinned"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack text-warning",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('b-avatar', {
    staticClass: "mr-1",
    attrs: {
      "src": _vm.getStaffAvatar(_vm.chatroom)
    }
  }), _c('b-avatar', {
    staticClass: "mr-3",
    attrs: {
      "src": _vm.getCustomerAvatar(_vm.chatroom)
    }
  }), _c('div', {
    staticClass: "font-weight-bold title-and-message"
  }, [_c('p', {
    staticClass: "chatroom-title",
    attrs: {
      "title": _vm.title
    }
  }, [_vm.category ? _c('b-badge', {
    staticClass: "text-primary",
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(_vm._s(_vm.category))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title) + " ")], 1), _c('p', {
    class: _vm.hasUnreadMessage ? 'text-bold' : 'text-muted small',
    attrs: {
      "title": _vm.lastMessage
    }
  }, [_vm._v(" " + _vm._s(_vm.lastMessage) + " ")])]), _c('div', {
    staticClass: "info"
  }, [_c('time', {
    staticClass: "text-muted small"
  }, [_vm.chatroom.message.updated_at ? [_vm._v(" " + _vm._s(_vm.formatDate(_vm.chatroom.message.updated_at)) + " ")] : [_vm._v(" ")]], 2), _c('div', {
    staticClass: "badges"
  }, [_vm.chatroom.status ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": _vm.chatroomStatusVariantMapping[_vm.chatroom.status]
    }
  }, [_vm._v(" " + _vm._s(_vm.chatroomStatusTextMapping[_vm.chatroom.status]) + " ")]) : _vm._e(), _vm.chatroom.is_new_created || _vm.chatroom.is_new ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "outline-info"
    }
  }, [_vm._v(" New ")]) : _vm._e(), _vm.hasUnreadMessage ? _c('b-badge', {
    attrs: {
      "pill": "",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.unreadCount) + " ")]) : _vm._e()], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }